import React, { useState } from "react";
import { useAuth } from "../AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await login(username, password);
    } catch (err) {
      setError(err.response?.status === 401
        ? "Invalid username or password"
        : "Unable to reach the plant server");
      setBusy(false);
    }
  };

  return (
    <div className="login-screen" data-testid="login-screen">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">
          <div className="login-title">AARTI INDUSTRIES — JHAGADIA</div>
          <div className="login-sub">Chemical OIM · Operational Intelligence Module</div>
        </div>

        <span className="pill warning login-pill">
          <span className="dot" /> Restricted Access — Authorized Personnel Only
        </span>

        <label className="login-label" htmlFor="login-username">Username</label>
        <input
          id="login-username"
          className="login-input"
          data-testid="login-username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoComplete="username"
          autoFocus
        />

        <label className="login-label" htmlFor="login-password">Password</label>
        <input
          id="login-password"
          className="login-input"
          data-testid="login-password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
        />

        {error && (
          <div className="login-error" data-testid="login-error">⚠ {error}</div>
        )}

        <button
          className="btn primary login-submit"
          data-testid="login-submit"
          type="submit"
          disabled={busy || !username || !password}
        >
          {busy ? "Authenticating…" : "Sign In"}
        </button>

        <div className="login-footer">
          © 2026, Saarv Solutions Private Limited. All Rights Reserved.
        </div>
      </form>
    </div>
  );
}
